import React from 'react';

export default function Edit() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
      <g clipPath="url(#clip0_431_35715)">
        <path
          d="M22.9499 4.87578C21.7499 3.60078 20.4749 2.32578 19.1999 1.08828C18.9374 0.825781 18.6374 0.675781 18.2999 0.675781C17.9624 0.675781 17.6249 0.788281 17.3999 1.05078L3.26237 15.0758C3.03737 15.3008 2.88737 15.5633 2.77487 15.8258L0.71237 22.1258C0.59987 22.4258 0.67487 22.7258 0.82487 22.9508C1.01237 23.1758 1.27487 23.3258 1.61237 23.3258H1.76237L8.17487 21.1883C8.47487 21.0758 8.73737 20.9258 8.92487 20.7008L22.9874 6.67578C23.2124 6.45078 23.3624 6.11328 23.3624 5.77578C23.3624 5.43828 23.2124 5.13828 22.9499 4.87578ZM7.72487 19.5383C7.68737 19.5758 7.64987 19.5758 7.61237 19.6133L2.77487 21.2258L4.38737 16.3883C4.38737 16.3508 4.42487 16.3133 4.46237 16.2758L14.7749 6.00078L18.0374 9.26328L7.72487 19.5383ZM19.1999 8.06328L15.9374 4.80078L18.2249 2.51328C19.3124 3.56328 20.3999 4.68828 21.4499 5.77578L19.1999 8.06328Z"
          fill="#637381"
        />
      </g>
      <defs>
        <clipPath id="clip0_431_35715">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
